var _close_vacancy = ( function ( $ ) {

	var $elem;

	var _init = function () {
		$( 'a.edit-link.archive-vacancy' ).on( 'click', _maybe_archive_vacancy );
	};

	var _maybe_archive_vacancy = function ( e ) {
		e.preventDefault();
		$elem = $( this );

		var should_archive_vacancy = confirm( 'Are you sure you want to close your vacancy? This cannot be undone.' );

		if ( should_archive_vacancy ) {
			_start_spinner();
			var $id = $( this ).data( 'vacancy' );

			_archive_vacancy( $id );
		}
	};

	var _archive_vacancy = function ( vacancy_id ) {
		var $data = {
			action: 'archive_vacancy',
			nonce: ScriptData.archive_vacancy_nonce,
			vacancy_id: vacancy_id
		};

		$.post( ScriptData.ajaxurl, $data, _archive_vacancy_response );
	};

	var _archive_vacancy_response = function ( response ) {
		if ( ! response.success ) {
			_stop_spinner();
		}

		window.location.reload();
	};

	var _start_spinner = function () {
		$elem.closest( '.my-vacancy-card' ).find( '.ajax-spinner' ).addClass( 'active' );
	};

	var _stop_spinner = function () {
		$elem.closest( '.my-vacancy-card' ).find( '.ajax-spinner' ).removeClass( 'active' );
	};

	if ( $( 'body.page-vacancies' ).length > 0 ) {
		$( document ).ready( _init );
	}

} )( jQuery );

module.exports = _close_vacancy;